import styled from "styled-components";
import { motion } from "framer-motion";

import MainInterface from "./interface"

const Main = styled(motion.div)`
    padding-left: 0px;
    padding-right: 10px;
    display: block;
    padding-bottom:40px;

    @media (max-width: 600px){
        padding-right: 0px;
        display: ${(p: MainInterface) => p.isFormVisible ? "none" : "block"};
    }

    @media (max-width: 992px){
        padding-bottom: ${(p: MainInterface) => p.isFormVisible ? "0px" : "40px"};
    }
`;

export default Main;